export const MockCartData = {
    token: "Z2NwLXVzLWNlbnRyYWwxOjAxSk05OEdHRkM1UVJKRVYySFc4TVdUQlo3?key=b4b93bfa9e86577468a6918f8d96543e",
    note: "",
    attributes: {},
    original_total_price: 160000,
    total_price: 144000,
    total_discount: 0,
    total_weight: 454,
    item_count: 2,
    items: [
        {
            id: 49962792157506,
            properties: {},
            quantity: 2,
            variant_id: 49962792157506,
            key: "49962792157506:387c6c124821728d39ed2060218f3f04",
            title: "Placeholder Product",
            price: 80000,
            original_price: 160000,
            presentment_price: 800,
            discounted_price: 80000,
            line_price: 160000,
            original_line_price: 160000,
            total_discount: 10,
            discounts: [
                {
                    amount: 9000,
                    title: "Bundle Discount",
                },
            ],
            sku: "110",
            grams: 0,
            vendor: "testing kefi",
            taxable: true,
            product_id: 9776940384578,
            product_has_only_default_variant: true,
            gift_card: false,
            final_price: 80000,
            final_line_price: 144000,
            url: "/products/black-semi-casual?variant=49962792157506",
            featured_image: {
                aspect_ratio: 1.747,
                alt: "black",
                height: 170,
                url: "",
                width: 297,
            },
            image: "",
            handle: "placeholder-product",
            requires_shipping: true,
            product_type: "",
            product_title: "Placeholder Product",
            product_description: "",
            variant_title: null,
            variant_options: ["Default Title"],
            options_with_values: [
                {
                    name: "Color",
                    value: "Orange",
                },
                {
                    name: "Size",
                    value: "M",
                },
            ],
            line_level_discount_allocations: [
                {
                    amount: 24870,
                    discount_application: {
                        type: "",
                        key: "2e01eb39-cb83-457c-8825-21c708e1f01d",
                        title: "Buy 2, Save 10%",
                        description: null,
                        value: "15.0",
                        created_at: "2025-06-04T10:42:47.275Z",
                        value_type: "percentage",
                        allocation_method: "across",
                        target_selection: "entitled",
                        target_type: "line_item",
                        total_allocated_amount: 24870,
                    },
                },
            ],
            line_level_total_discount: 0,
            quantity_rule: {
                min: 1,
                max: null,
                increment: 1,
            },
            has_components: false,
        },
    ],
    requires_shipping: true,
    currency: "INR",
    items_subtotal_price: 158400,
    cart_level_discount_applications: [],
};
